import { StateNode } from "@tldraw/editor";
import { Erasing } from "./childStates/Erasing.mjs";
import { Idle } from "./childStates/Idle.mjs";
import { Pointing } from "./childStates/Pointing.mjs";
class EraserTool extends StateNode {
  static id = "eraser";
  static initial = "idle";
  static isLockable = false;
  static children() {
    return [Idle, Pointing, Erasing];
  }
  info = {};
  onEnter(info = {}) {
    this.info = info;
    if (info.onInteractionEnd) {
      this.setCurrentToolIdMask(info.onInteractionEnd);
    }
    this.editor.setCursor({ type: "cross", rotation: 0 });
  }
  onExit() {
    this.setCurrentToolIdMask(void 0);
    this.info = {};
  }
  maybeReturnToOriginatingTool() {
    const { onInteractionEnd } = this.info;
    if (!onInteractionEnd) return;
    this.editor.setCurrentTool(onInteractionEnd);
  }
}
export {
  EraserTool
};
//# sourceMappingURL=EraserTool.mjs.map
